import { ImageType } from 'utils/types';

import { TakeoverBannerProps } from './TakeoverBanner';

export const parseTakeoverBanner = ({
  eyebrow,
  metadata,
  body,
  images,
}: Queries.ContentfulSection001): TakeoverBannerProps => {
  const { title, theme, ctas } = metadata ?? {};

  let desktopImages: ImageType[] = [];
  let mobileImages: ImageType[] = [];

  desktopImages = images?.map((image) => ({
    gatsbyImageData: image?.desktopImage?.gatsbyImageData,
    description: image?.desktopImageAltText || '',
  })) as ImageType[];

  mobileImages = images?.map((image) => ({
    gatsbyImageData: image?.mobileImage?.gatsbyImageData,
    description: image?.mobileImageAltText || '',
  })) as ImageType[];

  return {
    eyebrow: eyebrow ?? '',
    title: title ?? '',
    description: {
      raw: body?.raw || '',
    },
    cta: {
      displayName: ctas?.[0]?.displayName ?? '',
      label: ctas?.[0]?.label ?? '',
      url: ctas?.[0]?.url ?? '',
      // @ts-ignore
      metadata: ctas?.[0]?.metadata ?? {},
    },
    backgroundColor: theme?.backgroundColor ?? '',
    desktopImages,
    mobileImages,
  };
};
